import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'domesticCity',
  standalone: true
})
export class DomesticPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    const str: string[] = value.split(',');
    if(str[str.length-1].toLowerCase() === 'canada'){
      return `${str[0]}, ${str[1]}`;
    }
    return value;
  }

}
